module.exports = __webpack_public_path__ + "img/287.0e2c9e19.png";